import {XauditModel} from '../xaudit.model';
import {AddressDataModel} from './address-data.model';
import {ContactCommsDataModel} from './contact-comms-data.model';

export class ContactDataModel extends XauditModel {
  AKA: string = '';
  BirthDate: Date;
  ContactId: string = '';
  Description: string = '';
  FirstName: string = '';
  // TODO: Incorrect spelling fix, but must be reflected on the backend and db.
  GovermentIdentificationNo1: string = '';
  GovermentIdentificationNo2: string = '';
  GovermentIdentificationNo3: string = '';
  LOCID: number;
  LastName: string = '';
  MidName: string = '';
  ValidValueItemId: string = '';
  enumContactCategoryID: string = '';
  enumGenderID: string = '';
  enumNameSuffixID: string = '';
  enumSalutationID: string = '';
  // TODO: Incorrect spelling fix, but must be reflected on the backend and db.
  isVisibleGovermentIdentificationNo1: string = '';
  isVisibleGovermentIdentificationNo2: string = '';
  isVisibleGovermentIdentificationNo3: string = '';
  enumPatientContactTypeID: string;

  dataAddresses: AddressDataModel[] = [];
  dataContactComms: ContactCommsDataModel[] = [];


  dataContactContacts: ContactDataModel[] = [];
  mainPhoneCommunication: ContactCommsDataModel;
  mainEmailCommunication: ContactCommsDataModel;
}
